import TejasImage from "../../assets/images/projects/tejas.png";
import { PersonalInfo } from '../types';

export const personalInfo: PersonalInfo = {
    name: 'Tejas Rana',
    email: 'contact@tejasrana.in',
    phone: '+91 9709462958',
    about: 'Full Stack Developer with 5+ years of experience building scalable, full-stack cloud-native applications across enterprise and SaaS platforms. I specialize in microservices architecture, serverless technologies, and secure authentication systems. Passionate about creating efficient, maintainable solutions that drive business value while mentoring teams and fostering collaborative environments.',
    profile: '/tr_logo.png',
    image: TejasImage,
    resume: '/resume.pdf',
}; 